// extracted by mini-css-extract-plugin
export const galleryLinks = "gallery-links-module--gallery-links--1hH3v";
export const grid = "gallery-links-module--grid--lC6L9";
export const gridItem = "gallery-links-module--grid-item--1HFuB";
export const overlay = "gallery-links-module--overlay--3nneZ";